module.exports = __webpack_public_path__ + "img/pic-paging-service-3-1.52870f6a.jpg";